import axios from 'axios';
import router from '../router'; // 导入router实例
import store from '../store'; // 导入store实例

const apiOrigin = process.env.VUE_APP_API_ORIGIN || 'http://localhost:8000';

const service = axios.create({
  // 去掉前端代理后，统一直接后端域名；可通过环境变量覆盖。
  baseURL: apiOrigin,
  timeout: 9000
});

// 请求拦截器 - 发送数据之前的处理
service.interceptors.request.use(
    config => {
      // 在请求发送前的处理逻辑
      const token = localStorage.getItem('access_token'); // 获取 Token
      if (token) {
        config.headers.Authorization = `Bearer ${token}`; // 添加认证信息到请求头
      }
      return config;
    },
    error => {
      // 处理请求错误
      return Promise.reject(error);
    }
  );
  
  // 响应拦截器  接收数据前的处理
  service.interceptors.response.use(
    response => {
      // 检查 response 是否存在
      if (response && response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    error => {
      // 处理响应错误
      let { response } = error;
  
      // 检查 response 是否存在
      if (!response) {
        // 网络错误
        console.error('Network Error');
        return Promise.reject(new Error('Network Error'));
      }
  
      // 特殊处理401错误（认证失败）
      if (response.status === 401) {
        handleAuthFailure();
        return Promise.reject(error);
      }
  
      // 调用定义的不同错误码处理的函数
      errorHandle(response.status, response.data);
  
      return Promise.reject(error);
    }
  );

  // 登录失效统一处理函数
  const handleAuthFailure = () => {
    // 清除过期的认证信息
    localStorage.removeItem('access_token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('ms_username');
    localStorage.removeItem('userRole');
    localStorage.removeItem('savedUsername');
    
    // 更新Vuex状态
    store.commit('logout');
    
    // 提示用户登录已失效
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.prototype.$message.warning('登录已失效，请重新登录');
    }
    
    // 跳转到登录页
    if (typeof router !== 'undefined' && router.currentRoute.path !== '/login') {
      router.push('/login');
    }
  }

  // 不同错误码的处理
const  errorHandle = (status, info) => {
    switch(status){
        case 400:
            console.log("语义错误");
            break;
        case 401:
            console.log("服务器认证失败");
            break;
        case 500:
            console.log("地址错误");
            break;
        case 502:
            console.log("服务器遇到意外");
            break;
        default:
            console.log("服务器无响应");
            break;
    }
}


  
 
  export default service;